import { USER_PWD_ERR_MSG_LENGTH } from 'constants/validMsg.js';
import { USER_PWD_ERR_MSG_UPPERCASE } from 'constants/validMsg.js';
import { USER_PWD_ERR_MSG_LOWERCASE } from 'constants/validMsg.js';
import { USER_PWD_ERR_MSG_NUMBER } from 'constants/validMsg.js';
import { USER_PWD_ERR_MSG_SYMBOL } from 'constants/validMsg.js';

/**
 * @param {string} value
 * @returns {Object} result - error message with boolean type.
 */
const validatePwd = (value) => {
	let result = { isErr: false, errMsg: '' };

	if (value.length === 0) {
		return result;
	} else if (value.length < 8 || value.length > 30) {
		result = { isErr: true, errMsg: USER_PWD_ERR_MSG_LENGTH };
		return result;
	} else if (value.length > 7 && value.length < 30) {
		const uppercaseCount = (value.match(/[A-Z]/g) || []).length;
		const lowercaseCount = (value.match(/[a-z]/g) || []).length;
		const numberCount = (value.match(/[0-9]/g) || []).length;
		const symbolCount = (value.match(/\W/g) || []).length;

		if (uppercaseCount < 1) {
			result = { isErr: true, errMsg: USER_PWD_ERR_MSG_UPPERCASE };
			return result;
		} else if (lowercaseCount < 1) {
			result = { isErr: true, errMsg: USER_PWD_ERR_MSG_LOWERCASE };
			return result;
		} else if (numberCount < 1) {
			result = { isErr: true, errMsg: USER_PWD_ERR_MSG_NUMBER };
			return result;
		} else if (symbolCount < 1) {
			result = { isErr: true, errMsg: USER_PWD_ERR_MSG_SYMBOL };
			return result;
		} else {
			return result;
		}
	}
};

export default validatePwd;
